import React from "react";
import EpochMonthService from "../../../services/EpochMonth.service";
import { Calendar1 } from "lucide-react";

interface MonthSelectorProps {
  epochMonth: number;
  setEpochMonth: (epochMonth: number) => void;
  minMonth?: number;
  maxMonth?: number;
}

const MonthSelector: React.FC<MonthSelectorProps> = ({
  epochMonth,
  setEpochMonth,
  minMonth = EpochMonthService.getTodayEpochMonth() - 24,
  maxMonth = EpochMonthService.getTodayEpochMonth(),
}) => {
  const getMonthLabel = (epochMonth: number) => {
    return EpochMonthService.epochMonthToMMMYY(epochMonth);
  };

  const generateMonthOptions = () => {
    const options = [];
    for (let month = maxMonth; month >= minMonth; month--) {
      options.push(
        <option key={month} value={month}>
          {getMonthLabel(month)}
        </option>
      );
    }
    return options;
  };

  return (
    <div className="flex flex-row items-center space-x-2 bg-white justify-center">
      <Calendar1 className="ml-1 text-slate-500" />
      <select
        value={epochMonth}
        onChange={(e) => setEpochMonth(Number(e.target.value))}
        className="p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {generateMonthOptions()}
      </select>
    </div>
  );
};

export default MonthSelector;